module.exports = __webpack_public_path__ + "static/media/Gilroy-Black.2ab58c19.ttf";